export enum AdvertisingEnum {
  id = '_id',
  name = 'name',
  description = 'description',
  images = 'images',
  tablets = 'tablets',
  active = 'active',
  view = 'view',
  created_by = 'created_by',
  client = 'client',
  branches = 'branches',
  contract = 'contract',
  start_date = 'start_date',
  end_date = 'end_date',
  createdAt = 'createdAt',
  updatedAt = 'updatedAt',
}
